var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 10.4165C9.38063 10.4165 10.4999 9.29722 10.4999 7.9165C10.4999 6.53579 9.38063 5.4165 7.99992 5.4165C6.61921 5.4165 5.49992 6.53579 5.49992 7.9165C5.49992 9.29722 6.61921 10.4165 7.99992 10.4165Z",
    stroke: "#85888E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 18.3332C9.66659 14.9998 14.6666 12.8484 14.6666 8.33317C14.6666 4.65127 11.6818 1.6665 7.99992 1.6665C4.31802 1.6665 1.33325 4.65127 1.33325 8.33317C1.33325 12.8484 6.33325 14.9998 7.99992 18.3332Z",
    stroke: "#85888E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.d5db8390b09ca3e1098b43ed65830e40.svg";
export { ForwardRef as ReactComponent };